import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import { ReactComponent as TwitchIcon } from 'assets/icons/social-media/twitch.svg';
import { ReactComponent as KickIcon } from 'assets/icons/social-media/kick.svg';
import { ReactComponent as MaterialSpinner } from 'assets/icons/material-spinner.svg';

import { apiUrl } from 'utils/http';

import Text from '../../../../../components/Text';
import InfoTooltip from '../../../../../components/InfoTooltip';
import { Button } from '../../../../../components/IconButton';

// prettier-ignore
import { StatusControl, StatusTextAdditional, StatusTextGroup, StatusTextHeading, StatusWrapper, } from '../styles';

export const redirectToTwitchOrKickAuthorization = service => {
  const redirectUri = `${apiUrl}/user/connect/${service}`;
  setTimeout(() => {
    window.location.assign(redirectUri);
  }, 1000);
};

const PLATFORMS = {
  twitch: {
    name: 'Twitch',
    Icon: TwitchIcon,
    redirect: () => redirectToTwitchOrKickAuthorization('twitch'),
  },
  kick: {
    name: 'Kick',
    Icon: KickIcon,
    redirect: () => redirectToTwitchOrKickAuthorization('kick'),
  },
};

const Status = ({ targetEl, connected, platform }) => {
  const { name, Icon, redirect } = PLATFORMS[platform];
  const [loading, setLoading] = useState(false);

  const handleRedirect = () => {
    setLoading(true);
    redirect();
  };

  const renderButton = () => (
    <Button
      $variant="contained"
      $size="large"
      $color={connected ? 'black' : 'green'}
      onClick={handleRedirect}
      disabled={loading}
    >
      <>
        {loading ? (
          <MaterialSpinner style={{ width: 13, height: 13 }} />
        ) : (
          <Icon style={{ width: 13, height: 13 }} />
        )}
        {connected ? 'Połączono' : `Połącz z ${name}`}
      </>
    </Button>
  );

  return createPortal(
    <StatusWrapper>
      <StatusTextGroup>
        <StatusTextHeading>Status połączenia</StatusTextHeading>
        <StatusTextAdditional>
          {`z platformą ${name}`}
          <InfoTooltip
            content={
              <>
                <Text>
                  Status wskazuje czy połączenie jest aktywne i czy konta Kick lub Twitch są
                  poprawnie połączone z Tipply.
                </Text>
                <Text>
                  Jeśli konta są połączone, by aktywować funkcję musisz włączyć ją jeszcze poniżej
                  za pomocą odpowiedniego switcha.
                </Text>
              </>
            }
            placement="right"
            theme="dark"
          />
        </StatusTextAdditional>
      </StatusTextGroup>

      <StatusTextGroup>
        <StatusControl variant={connected ? 'success' : 'error'}>
          {connected ? 'Połączono pomyślnie' : 'Brak połączenia'}
        </StatusControl>
        <div>{connected ? 'Kliknij i połącz ponownie:' : 'Kliknij i połącz z platformą:'}</div>
      </StatusTextGroup>

      {renderButton()}
    </StatusWrapper>,
    targetEl,
  );
};

export default Status;
